import { CharacterData } from '../types/character';
import { 
  ClassProvider, 
  ClassSectionComponent, 
  ClassCombatComponent 
} from '../utils/ClassComponentRegistry';

/**
 * Abstract base class for implementing class-specific providers
 * Provides common functionality and enforces the provider interface
 */
export abstract class BaseClassProvider implements ClassProvider {
  abstract readonly className: string;
  abstract readonly characterSheetSections: ClassSectionComponent[];
  abstract readonly combatTrackerComponents: ClassCombatComponent[];

  /**
   * Default character validation - can be overridden by subclasses
   */
  validateCharacter(character: CharacterData): boolean {
    return character.class?.toLowerCase() === this.className.toLowerCase();
  }

  /**
   * Default character initialization - can be overridden by subclasses
   */
  initializeCharacter(character: CharacterData): Partial<CharacterData> {
    return {};
  }

  /**
   * Helper method to create section component definitions
   */
  protected createSection(
    component: ClassSectionComponent['component'],
    title: string,
    options: {
      priority?: 'high' | 'medium' | 'low';
      defaultExpanded?: boolean;
      order?: number;
    } = {}
  ): ClassSectionComponent {
    return {
      component,
      title,
      priority: options.priority || 'medium',
      defaultExpanded: options.defaultExpanded ?? false,
      order: options.order || 100
    };
  }

  /**
   * Helper method to create combat component definitions
   */
  protected createCombatComponent(
    component: ClassCombatComponent['component'],
    order: number = 100
  ): ClassCombatComponent {
    return {
      component,
      order
    };
  }
}